import SearchSelect, { SelectProps as SP } from "./SearchSelect";

export default SearchSelect;

export type SelectProps = SP;
